module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wendy Kann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Wendy Kann")]), _vm._v(" lives in Connecticut with her husband and children. "), _c('I', [_vm._v("Casting with a Fragile Thread")]), _vm._v(" is her first book.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gSU4RS/tc-custom/9781466802117.jpg?1731799936504",
      "alt": "This image is the cover for the book Casting with a Fragile Thread"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Casting with a Fragile Thread\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this poignant, lyric memoir, a sister's tragic death prompts a woman's unbidden journey into her turbulent African past.")]), _c('br'), _c('br'), _vm._v("A comfortable suburban housewife with three children living in Connecticut, Wendy Kann thought she had put her volatile childhood in colonial Rhodesia—now Zimbabwe—behind her. Then one Sunday morning came a terrible phone call: her youngest sister, Lauren, had been killed on a lonely road in Zambia. Suddenly unable to ignore her longing for her homeland, she decides she must confront the ghosts of her past."), _c('br'), _c('br'), _vm._v("Wendy Kann's is a personal journey, set against a backdrop as exotic as it is desolate. From a privileged colonial childhood of mansions and servants, her story moves to a young adulthood marked by her father's death, her mother's insanity, and the viciousness of a bloody civil war. Through unlikely love she finds herself in the incongruous sophistication of Manhattan; three children bring the security of suburban America, until the heartbreaking vulnerability of the small child her sister left behind in Africa compels her to return to a continent she hardly recognizes."), _c('br'), _c('br'), _vm._v("With honesty and compassion, Kann pieces together her sister's life, explores the heartbreak of loss and belonging, and finally discovers the true meaning of home.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0